<!--- COMPONENTE PCVistaVolcarUL  ---->
<!---
Descripción del componente:
---------------------------
-

Eventos del componente:
-----------------------
-  xxxxxxxxxxx ->
--->
<template>
  <div class="div-componentePCVistaVolcarUL">
    <!-- <pre> {{ articuloNumeroSerieActivo }}</pre> -->
    <div class="div-ttlNumeroSerie">
      <span class="span-ttlNumeroSerie">
        {{ $t('production.dump.logisticUnit.serialNumber', { serialNumber: articuloNumeroSerieActivo.NumeroSerie }) }}
      </span>
    </div>
    <div style="width: 100%;">
      <div
        v-if="articuloNumeroSerieActivo.Existencias.length === 1"
        class="span-texto-azulOscuro-22-500 div-ttlPartidadDelPale"
      >
        {{ `${$t('common.batchPallet')}:` }}
      </div>
      <div
        v-if="articuloNumeroSerieActivo.Existencias.length > 1"
        class="span-texto-azulOscuro-22-500 div-ttlPartidadDelPale"
      >
        {{ $t('production.dump.logisticUnit.multipleBatches') }}
      </div>
      <span
        v-if="articuloNumeroSerieActivo.DatosOrigen != null"
        class="btn-oval-azulOscuro-26 btn-InformacionDatosOrigen seleccionable btn-informacionDatosOrigen"
        @click="AbrirDatosOrigenPale"
      >
        {{ $t('production.dump.logisticUnit.originDataIconText') }}
      </span>
    </div>
    <div
      v-if="articuloNumeroSerieActivo.Existencias"
      class="div-registrosPartidas"
    >
      <div class="div-elementoSeparador-total" />
      <div
        v-for="existencia in articuloNumeroSerieActivo.Existencias"
        :key="existencia.Id"
        class="div-registroPartida"
        @click="VerDetalle(existencia)"
      >
        <div class="display-flex flex-direction-column">
          <div class="partidas-unidad">
            <span class="span-numeroPartidaVistaUL">
              {{ `${$t('common.batch').toUpperCase()} ${existencia.Partida.Serie}/${existencia.Partida.Numero}` }}
            </span>
            <!-- <span
              v-if="articuloNumeroSerieActivo.DatosOrigen != null && articuloNumeroSerieActivo.DatosOrigen.length>0"
              class="span-texto-gris-1"
            >P.ORIGEN: {{ ObtenerCadenaNumerosPartidas(articuloNumeroSerieActivo.DatosOrigen) }} </span> -->
            <span class="span-envasesDisponibles">
              {{ $t('common.packages') }}
            </span>
          </div>
          <div
            v-if="articuloNumeroSerieActivo.DatosOrigen != null && articuloNumeroSerieActivo.DatosOrigen.length > 0"
            class="span-texto-gris-1"
          >
            {{ `${$t('common.originBatch').toUpperCase()}: ${ObtenerCadenaNumerosPartidas(articuloNumeroSerieActivo.DatosOrigen)}` }}
          </div>
          <div class="partidas-unidad">
            <span class="span-productoPartida"> {{ existencia.Articulo.Nombre }} </span>
            <div>
              <img
                class="img-iconoEnvases"
                alt="iconEnvases"
                src="@/static/icons/ic_box.svg"
              >
              <span class="span-existenciasEnvases">{{ existencia.Cajas }} </span>
            </div>
          </div>
        </div>
        <!-- <f7-row>
          <f7-col width="80">
            <span class="span-numeroPartidaVistaUL">PARTIDA {{ `${existencia.Partida.Serie}/${existencia.Partida.Numero}` }} </span>
            <br>
            <span
              v-if="articuloNumeroSerieActivo.DatosOrigen != null && articuloNumeroSerieActivo.DatosOrigen.length>0"
              class="span-texto-gris-1"
            >P.ORIGEN: {{ ObtenerCadenaNumerosPartidas(articuloNumeroSerieActivo.DatosOrigen) }} </span>
          </f7-col>
          <f7-col
            width="20"
            class="col-envasesDisponibles"
          >
            <span class="span-envasesDisponibles">
              {{ $t('common.packages') }}
            </span>
          </f7-col>
        </f7-row>
        <f7-row>
          <f7-col
            width="70"
            class="col-productoPartida"
          >
            <span class="span-productoPartida"> {{ existencia.Articulo.Nombre }} </span>
          </f7-col>
          <f7-col
            width="30"
            class="col-cantidadEnvasesDisponibles"
          >
            <img
              class="img-iconoEnvases"
              alt="iconEnvases"
              src="@/static/icons/ic_box.svg"
            >
            <span class="span-existenciasEnvases">{{ existencia.Cajas }} </span>
          </f7-col>
        </f7-row> -->
        <f7-row>
          <PCOperacionesPersonalizadas
            class="operaciones-personalizadas"
            :app-theme="appTheme"
            :tipo-entidad="1"
            :entidad="existencia.Partida"
            formulario-padre="frmVolcarMercanciaUnidadLogistica"
            componente-aplicacion="PCVistaVolcarUL"
            :mostrar-precarga="false"
          />
        </f7-row>
      </div>
    </div>

    <!-- Botones de volcado -->
    <f7-row class="div-row-botonesDeVolcadoYRecuperado">
      <f7-col width="100">
        <f7-button
          fill
          class="btn-volcarTodo btn-color-oscuro-1 btn-tamaño-3"
          @click="VolcarTodaLaMercanciaDeUnidadLogistica()"
        >
          {{ $t('production.dump.logisticUnit.btnDumpEverythingText') }}
        </f7-button>
      </f7-col>
    </f7-row>

    <!-- popup-DatosOrigenPale -->
    <f7-popup
      class="popup-DatosOrigenPale"
      :opened="popupDatosOrigenPale"
      @popup:closed="popupDatosOrigenPale = false"
    >
      <f7-navbar
        :title="$t('production.dump.logisticUnit.originPalletDataPopup.title')"
        sliding
        :style="appTheme"
      >
        <f7-nav-right>
          <f7-link @click="popupDatosOrigenPale = false">
            <img
              :src="icClose"
            >
          </f7-link>
        </f7-nav-right>
      </f7-navbar>
      <div>
        <div class="div-contenidoPartidasDatosOrigen">
          <!-- Cabecera Formulario -->
          <div class="div-cabeceraContenidoDatosPartidaOrigen">
            <f7-row>
              <f7-col width="60">
                <span class="span-ttlPartidasOrigen">
                  {{ $t('production.dump.logisticUnit.originPalletDataPopup.rowTitle') }}
                </span>
                <!-- <pre> {{ articuloNumeroSerieActivo }}</pre> -->
              </f7-col>
            </f7-row>
          </div>
          <div class="div-elementoSeparador-total" />
          <f7-row class="row-elementosContenidoDatosPartidaOrden">
            <f7-col
              v-for="(datoOrigen, index) in articuloNumeroSerieActivo.DatosOrigen"
              :key="index"
              width="100"
            >
              <f7-col width="80">
                <span class="span-texto-gris-1">
                  {{ `${$t('common.batch').toUpperCase()} ${datoOrigen.Partida.Serie}/${datoOrigen.Partida.Numero}` }}
                </span>
              </f7-col>
            </f7-col>
          </f7-row>
        </div>
      </div>
    </f7-popup>
  </div>
</template>

<script>
import { mapState, mapWritableState } from 'pinia';
import { useTraceabilityStore } from '@/js/stores/traceability';
import { useParamRef } from '@erpagroapp/params';
import { useSettingRef } from '@erpagroapp/settings';

import { Log, LogError } from '@/js/common/HIDebuggingSupport';
import ConexionTA from '@/js/services/traceability/APITraceability';
import eventBus from '@/js/event-bus';
import icClose from '@/static/icons/ic_close.svg';
import { ConfirmDialogGH, HiDialog, HiNotification } from '@/js/common/HINotificationSupport';
import { f7 } from 'framework7-vue';
import { ModuleProcessMappings } from '@erpagroapp/common';
import PCOperacionesPersonalizadas from './PCOperacionesPersonalizadas.vue';

export default {
  name: 'PCVistaVolcarUL',
  components: {
    PCOperacionesPersonalizadas,
  },

  data() {
    return {
      articuloNumeroSerieActivo: null, // Contiene la unidad logisitica actual.
      popupDatosOrigenPale: false, // Muestra el popup con la información de los datos origen.
      validarPartidasAnterioresVolcadoLocal: false,
      icClose,
      comprobarCompatibilidadVolcadoAPedido: useParamRef('ComprobarCompatibilidadVolcadoAPedido'),
      validarPartidasAnterioresVolcado: useParamRef('ValidarPartidasAnterioresVolcado'),
      confirmacionAntesDeVolcar: useSettingRef('Volcado.ConfirmacionAntesDeVolcar'),
    };
  },
  computed: {
    ...mapState(useTraceabilityStore, [
      'puntoDeVolcadoSeleccionado',
      'lineaDeProduccionSeleccionada',
    ]),

    ...mapWritableState(useTraceabilityStore, [
      'unidadLogisticaSeleccionada',
    ]),

    appTheme() {
      return {
        '--f7-navbar-text-color': '#fff',
      };
    },
  },

  created() {
    this.InicializarComponente();
    this.ActivarListener();
    this.articuloNumeroSerieActivo = this.unidadLogisticaSeleccionada;
    // this.ObtenerInformacionArticuloNumeroSerie();
    this.ComprobarVolcadoSinConfirmacion();
  },
  beforeUnmount() {
    this.DesactivarListener();
    this.unidadLogisticaSeleccionada = null; // Restablecemos la UL Seleccionada
  },

  methods: {
    InicializarComponente() {
      Log(this, this.InicializarComponente.name);
      this.validarPartidasAnterioresVolcadoLocal = this.validarPartidasAnterioresVolcado; // Solo se comprueba si en ERP esta configurado este parametro.
    },
    ActivarListener() {
      Log(this, this.ActivarListener.name);
      // EventBus para ser llamados desde otros Componentes.
      eventBus.on('PCVistaVolcarPartida_mercanciaVolcada', () => {
        this.PartidaDeUnidadLogisiticaVolcada();
        this.NotificarVolcadoDeMercancia();
      });
    },
    DesactivarListener() {
      Log(this, this.DesactivarListener.name);
      eventBus.off('PCVistaVolcarPartida_mercanciaVolcada');
    },

    /**
     * @public
     * @returns {void}
     */
    ActualizarDatos() {
      Log(this, this.ActualizarDatos.name);
      this.articuloNumeroSerieActivo = this.unidadLogisticaSeleccionada;
      this.ObtenerInformacionArticuloNumeroSerie();
    },

    VerDetalle(objExistencia) { // Sol.235516
      Log(this, this.VerDetalle.name);
      /* this.idPartidaSeleccionada = idPartidaSeleccionada;
      this.partidaSeleccionada = idPartidaSeleccionada;
      const existenciasNuevas = this.articuloNumeroSerieActivo.Existencias;
      this.ExistenciasVolcado = existenciasNuevas; */
      f7.views.main.router.navigate('/production/traceability/dumpAndRecoverMerchandise/dump/FrmDetailDumpMerchandise', {
        props: {
          existenciaSeleccionada: objExistencia,
          partidaSeleccionada: objExistencia.Partida,
        },
      });
      // this.unidadLogisticaSeleccionada = nuevaUnidadLogistica;
    },

    ObtenerInformacionArticuloNumeroSerie() {
      Log(this, this.ObtenerInformacionArticuloNumeroSerie.name);
      const self = this;
      HiDialog.Preloader(true, this.$t('production.dump.logisticUnit.get.preloaderText'));
      ConexionTA.callObteneElementoDeProduccionPorIdArticuloNumeroSerie(this.articuloNumeroSerieActivo.Id).then((result) => {
        if (result.Valor) {
          self.articuloNumeroSerieActivo = result.UnidadContenedora;

          HiDialog.Preloader(false);
          if (!result.EstaEnExistencias) { // No existe mas mercancia del ArticuloNumeroSerie
            f7.popup.close('.vistaMercanciaUL-popup', true);
          }
        } else {
          HiDialog.Preloader(false);
          // if (result.Codigo === 600) { // No existe mas mercancia del ArticuloNumeroSerie
          //  f7.popup.close('.vistaMercanciaUL-popup', true);
          // } else {
          HiDialog.Preloader(false);
          HiNotification.Alert(result.Mensaje, this.$t('common.error'));
          // }
        }
      })
        .catch(() => {
          HiDialog.Preloader(false);
          HiNotification.Alert(this.$t('common.checkYourConnection'), this.$t('common.error'));
          LogError('error');
        });
    },

    async VolcarTodaLaMercanciaDeUnidadLogistica() {
      Log(this, this.VolcarTodaLaMercanciaDeUnidadLogistica.name);
      const self = this;
      if (this.comprobarCompatibilidadVolcadoAPedido) {
        const compativilidadOK = await this.ComprobarCompatibilidadVolcadoAPedido();
        if (!compativilidadOK) {
          return;
        }
      }
      if (this.validarPartidasAnterioresVolcadoLocal) {
        const validarPartidasAnterioresVolcadoOK = await this.ComprobarExistenciaPartidasAnterioresParaVolcado();
        if (!validarPartidasAnterioresVolcadoOK) {
          return;
        }
      }
      HiDialog.Preloader(true, this.$t('production.dump.batchDetails.dump.preloaderText'));
      const lineaDeProduccion = this.lineaDeProduccionSeleccionada;
      const puntoDeVolcado = this.puntoDeVolcadoSeleccionado;
      const idProceso = ModuleProcessMappings.ProductionControl.Processes.Dumping.Id;
      ConexionTA.callVolcarTodaLaMercanciaArticuloNumeroSerie(lineaDeProduccion.Id, puntoDeVolcado.Id, this.articuloNumeroSerieActivo.Id, idProceso).then((result) => {
        if (result.Valor) {
          const ultimasColasVolcadas = JSON.parse(result.Mensaje);
          self.AsociarLineasPedidoVentaVolcado(puntoDeVolcado, ultimasColasVolcadas);
          self.NotificarVolcadoTotalDeMercancia();
          HiDialog.Preloader(false);
        } else {
          HiDialog.Preloader(false);
          HiNotification.Alert(result.Mensaje, this.$t('common.error'));
        }
      })
        .catch(() => {
          HiDialog.Preloader(false);
          HiNotification.Alert(this.$t('common.checkYourConnection'), this.$t('common.error'));
          LogError('error');
        });
    },

    async ComprobarCompatibilidadVolcadoAPedido() {
      Log(this, this.ComprobarCompatibilidadVolcadoAPedido.name);
      const puntoVolcado = this.puntoDeVolcadoSeleccionado;
      if (!puntoVolcado.AsociarLineaPedido || (!puntoVolcado.LineasPedidoVentaAsociadas || puntoVolcado.LineasPedidoVentaAsociadas.length === 0)) {
        return true;
      }
      HiDialog.Preloader(true, this.$t('production.dump.batchDetails.validation.family.preloaderText'));
      const result = await ConexionTA.callComprobarCompatibilidadVolcadoAPedido(this.articuloNumeroSerieActivo.Existencias[0].Partida.Id, puntoVolcado.LineasPedidoVentaAsociadas);
      HiDialog.Preloader(false);
      if (result.Valor) {
        return true;
      }
      HiNotification.Alert(result.Mensaje, this.$t('production.dump.batchDetails.validation.family.errorAlertTitle'));
      return false;
    },

    async ComprobarExistenciaPartidasAnterioresParaVolcado() {
      Log(this, this.ComprobarExistenciaPartidasAnterioresParaVolcado.name);
      HiDialog.Preloader(true, this.$t('production.dump.batchDetails.validation.previousBatches.preloaderText'));
      const result = await ConexionTA.callComprobarExistenciaPartidasAnterioresParaVolcado(this.articuloNumeroSerieActivo.Existencias[0].Partida.Id, this.articuloNumeroSerieActivo.Id);
      HiDialog.Preloader(false);
      if (result.Valor) {
        return true;
      }

      const confirmationAlertTitle = this.$t('production.dump.batchDetails.validation.previousBatches.confirmationAlert.title');
      const confirmationAlertText = this.$t('production.dump.batchDetails.validation.previousBatches.confirmationAlert.text');

      return ConfirmDialogGH(confirmationAlertText, confirmationAlertTitle);
    },
    async AsociarLineasPedidoVentaVolcado(puntoVolcado, ultimasColasVolcado) {
      Log(this, this.AsociarLineasPedidoVentaVolcado.name);

      if (!puntoVolcado.AsociarLineaPedido || (!puntoVolcado.LineasPedidoVentaAsociadas || puntoVolcado.LineasPedidoVentaAsociadas.length === 0)) {
        return;
      }
      HiDialog.Preloader(true, this.$t('production.dump.batchDetails.associatingSalesOrder.preloaderText'));
      // await ConexionTA.callAsociarLineasPedidoVentaVolcadoXUnidadLogistica(puntoVolcado.Id, articuloNumeroSerie.Id, puntoVolcado.LineasPedidoVentaAsociadas);
      await ConexionTA.callAsociarVolcadosXLineasPedidoVenta(puntoVolcado.LineasPedidoVentaAsociadas, ultimasColasVolcado);
      HiDialog.Preloader(false);
    },

    ComprobarVolcadoSinConfirmacion() {
      Log(this, this.ComprobarVolcadoSinConfirmacion.name);
      if (this.confirmacionAntesDeVolcar) {
        return;
      } // Continuamos el proceso normal.
      this.VolcarTodaLaMercanciaDeUnidadLogistica(); // volcado sin confirmación activo.
    },

    NotificarVolcadoDeMercancia() {
      Log(this, this.NotificarVolcadoDeMercancia.name);
      eventBus.emit('PCVistaVolcarUL_mercanciaVolcada');
    },

    NotificarVolcadoTotalDeMercancia() {
      Log(this, this.NotificarVolcadoTotalDeMercancia.name);
      eventBus.emit('PCVistaVolcarUL_mercanciaTotalVolcada');
    },

    PartidaDeUnidadLogisiticaVolcada() {
      this.popupPartidaDeUnidadLogistica = false;

      this.ObtenerInformacionArticuloNumeroSerie(); // Actualizamos los datos.
    },

    AbrirDatosOrigenPale() {
      Log(this, this.AbrirDatosOrigenPale.name);
      this.popupDatosOrigenPale = true;
    },

    ObtenerCadenaNumerosPartidas(lstPartidas) {
      Log(this, this.ObtenerCadenaNumerosPartidas.name);
      let cadenaPartidas = '';
      try {
        lstPartidas.forEach((p) => {
          const seriePartida = p.Partida.Serie != null ? p.Partida.Serie : '';
          cadenaPartidas += `${seriePartida}/${p.Partida.Numero}, `;
        });
        cadenaPartidas = cadenaPartidas.slice(0, -2); // Quitamos el último carácter.
      } catch {
        LogError('error');
      }
      return cadenaPartidas;
    },
  },
};
</script>

<style lang="scss">
.div-componentePCVistaVolcarUL {
  margin: 15px;
  margin-top: 25px;
}

.div-ttlNumeroSerie {
  padding-top: 25px;
  padding-bottom: 14px;
}

.span-ttlNumeroSerie {
  color: var(--his-darkgray);
  font-size: 22px;
}

.span-ttlPartidasOrigen {
  color: var(--his-darkgray);
  font-size: 15px;
}

.div-registrosPartidas {
  display: inline-block;
  width: 100%;
}

.partidas-unidad {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 95vw;
}

.div-registroPartida {
  border-bottom: 1px solid var(--his-disabled);
  margin-bottom: 15px;
  padding: 12px;
}

.span-numeroPartidaVistaUL {
  color: var(--his-darkgray);
  font-size: 22px;
}

.span-productoPartida {
  font-size: 22px;
  color: #009ba6;
  padding-top: 7px;
}

.span-envasesDisponibles {
  font-size: 20px;
  color: var(--his-silver);
  text-align: right;
  display: flex;
  justify-content: center;
}

.span-existenciasEnvases {
  font-size: 20px;
  color: #282829;
  text-align: right;
}

.col-cantidadEnvasesDisponibles {
  text-align: right;
}

.img-iconoEnvases {
  padding-top: 5px;
  padding-left: 5px;
  padding-right: 5px;
}

.btn-volcarTodo {
  margin-top: 12px;
  margin-bottom: 10px;
  margin-left: 20px;
  margin-right: 20px;
  max-width: 260px;
}

.div-row-botonesDeVolcadoYRecuperado {
  text-align: -webkit-center;
}

.btn-informacionDatosOrigen {
  display: flex;
  float: right;
}

.div-ttlPartidadDelPale {
  display: flex;
  float: left;
}

.div-contenidoPartidasDatosOrigen {
  margin-top: 38px;
  margin-left: 16px;
  margin-right: 10px;
  overflow-y: auto;
}

.row-elementosContenidoDatosPartidaOrden {
  margin-top: 10px;
}
</style>
